import { Add, Delete } from '@mui/icons-material';
import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import React, { useCallback } from 'react';

interface Props {
  concentrations: any[];
  setConcentrations: (concentrations: any[]) => void;
  amount: number;
  subProducts: any[];
}

const SubProductItem = (props: any) => {
  const {
    index,
    concentration,
    concentrations,
    setConcentrations,
    deleteConcentration,
    handleSelectSubProduct,
    availableSubProducts,
  } = props;

  const handleChangeField = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
  ) => {
    const { name, value } = e.target;
    const newArray = [...concentrations];
    newArray[index][name] = value;
    setConcentrations(newArray);
  };

  return (
    <div key={index} style={{ display: 'flex' }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={2}>
          <FormControl key={index} variant="outlined" fullWidth>
            <InputLabel id="filter-label">Seleccionar</InputLabel>
            <Select
              labelId="filter-label"
              fullWidth
              id="Filtrar por estado"
              value={concentration.id}
              onChange={(e) => handleSelectSubProduct(e, index)}
              label="Seleccionar"
            >
              {availableSubProducts(index)
                .filter((x: any) => x.id !== 'warranty-premium')
                .map((x: any, index: any) => (
                  <MenuItem key={index} value={x.id}>
                    {x.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <TextField
            autoFocus
            margin="dense"
            label="C. Variable (%)"
            name="operationCostVariable"
            type="number"
            value={concentration.operationCostVariable}
            onChange={(e) => handleChangeField(e, index)}
            inputProps={{
              inputMode: 'decimal',
              min: 0,
              max: 100,
              step: 0.01,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            autoFocus
            margin="dense"
            label="C. Fija (UF)"
            name="operationCostFixed"
            type="number"
            value={concentration.operationCostFixed}
            onChange={(e) => handleChangeField(e, index)}
            inputProps={{
              inputMode: 'decimal',
              step: 0.01,
              min: 0,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            autoFocus
            margin="dense"
            label="Monto Total ($)"
            name="amount"
            type="number"
            value={concentration.amount ?? ''}
            onChange={(e) => handleChangeField(e, index)}
            inputProps={{
              inputMode: 'decimal',
              min: 0,
              step: 1,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            autoFocus
            margin="dense"
            label="Monto Max Operación ($)"
            name="maxDocumentAmount"
            type="number"
            value={concentration.maxDocumentAmount ?? ''}
            onChange={(e) => handleChangeField(e, index)}
            inputProps={{
              inputMode: 'decimal',
              min: 0,
              step: 1,
            }}
            fullWidth
          />
        </Grid>
      </Grid>
      <IconButton
        style={{ marginLeft: '10px' }}
        onClick={() => deleteConcentration(index)}
      >
        <Delete />
      </IconButton>
    </div>
  );
};

const SubPrductAssingnation: React.FC<Props> = (props) => {
  const { concentrations, setConcentrations, amount, subProducts } = props;
  const availableSubProductsCount = subProducts.filter(
    (x: any) => x.id !== 'warranty-premium',
  ).length;
  const canAddMore = concentrations.length < availableSubProductsCount;

  const addEmptyConcentration = useCallback(() => {
    if (canAddMore) {
      setConcentrations([...concentrations, {}]);
    }
  }, [concentrations, setConcentrations, canAddMore]);

  const deleteConcentration = (index: number) => {
    const newArray = [...concentrations];
    newArray.splice(index, 1);
    setConcentrations(newArray);
  };

  const handleSelectSubProduct = (e: any, index: number) => {
    const newArray = [...concentrations];
    const subProduct = subProducts.find((x: any) => x.id === e.target.value);
    if (!subProduct) return;
    newArray[index].subProductName = subProduct.name;
    newArray[index].id = subProduct.id;
    setConcentrations(newArray);
  };

  const availableSubProducts = (index: number) =>
    subProducts.filter(
      (x: any) =>
        !concentrations.map((x: any) => x.id).includes(x.id) ||
        concentrations[index].id === x.id,
    );

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography>
          Acá podrás asignar los detalles de tus subproductos
        </Typography>
        <div style={{ padding: '10px 0px', textAlign: 'right' }}>
          <CustomButton
            color="secondary"
            onClick={addEmptyConcentration}
            disabled={!canAddMore}
          >
            <Add /> Sub producto
          </CustomButton>
        </div>
      </div>
      <div style={{ padding: '10px 0px' }}>
        {concentrations.map((concentration: any, index: any) => (
          <div key={index}>
            <SubProductItem
              key={index}
              index={index}
              concentration={concentration}
              concentrations={concentrations}
              setConcentrations={setConcentrations}
              deleteConcentration={deleteConcentration}
              handleSelectSubProduct={handleSelectSubProduct}
              availableSubProducts={availableSubProducts}
              amount={amount}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubPrductAssingnation;
